/* PLATONIC MOTION — companion to platonic-motion.css (2026-07-31).
   Non-invasive by design: no existing file is modified, no existing
   handler is replaced. Reveals via IntersectionObserver; add-to-bag
   feedback via its own listeners; cart-count pop via MutationObserver.
   The Razorpay Magic buy button (.pl-cta-buy / injected .magic-buy-btn)
   is never touched. */
(function () {
  'use strict';

  function init() {
    var body = document.body;
    /* Tells the 3s failsafe in theme.liquid that the motion layer is
       running, so it leaves html.pl-m (the hidden states) in place. */
    window.plMotion = true;

    /* Arrival choreography (hero / PDP buy column). Double-rAF so the
       hidden state paints first. ~2s later the body is marked done,
       which strips the arrival transitions so buttons get their own
       hover timing back. The sessionStorage flag makes later pages
       skip the entrance entirely (html.arrived-before, set by the
       inline snippet in theme.liquid before first paint). */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { body.classList.add('is-arrived'); });
    });
    setTimeout(function () { body.classList.add('is-done'); }, 2100);
    try { sessionStorage.setItem('pl-arrived', '1'); } catch (e) { /* private mode */ }

    /* Reveal-on-scroll. Observes single elements (.fade-in) and stagger
       groups (.reveal-seq). After the longest possible reveal chain
       (~1.7s) each element is released back to its own transitions. */
    var els = document.querySelectorAll('.fade-in, .reveal-seq');
    if (els.length) {
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            el.classList.add('is-in');
            setTimeout(function () { el.classList.add('is-done'); }, 1800);
            obs.unobserve(el);
          });
        /* threshold 0 = reveal on the first visible pixel. It was 0.1,
           i.e. 10% of the element's own height — the 6-tile grid is
           ~3300px tall on phones, so it needed 330px on screen and an
           iPhone in Safari/Instagram (~660px tall, grid starting at
           ~320px) never got there: Essential Six sat blank until the
           visitor scrolled (2026-10-16). */
        }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
        els.forEach(function (el) { obs.observe(el); });
      } else {
        els.forEach(function (el) { el.classList.add('is-in', 'is-done'); });
      }
    }

    /* Theme-editor safety: a section re-render replaces its DOM, which
       would leave fresh .fade-in elements unobserved (invisible). In
       design mode, just show everything immediately. */
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (ev) {
        ev.target.querySelectorAll('.fade-in, .reveal-seq').forEach(function (el) {
          el.classList.add('is-in', 'is-done');
        });
      });
    }

    /* Add-to-bag feedback: soft pulse + label swaps to ADDED for a beat.
       Listens alongside the theme's own handlers — replaces nothing.
       Only non-buy-now triggers ([data-atc] without [data-buy-now]). */
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest && ev.target.closest('[data-atc]:not([data-buy-now])');
      if (!btn || btn.disabled || btn.dataset.plFlashing) return;
      var label = btn.querySelector('.pl-cta-label') || btn.querySelector('span');
      btn.dataset.plFlashing = '1';
      btn.classList.add('is-added-flash');
      var original = label ? label.textContent : null;
      if (label) label.textContent = 'ADDED ✓';
      setTimeout(function () {
        if (label && original !== null) label.textContent = original;
        btn.classList.remove('is-added-flash');
        delete btn.dataset.plFlashing;
      }, 1400);
    });

    /* Cart-count pop: watch the badge the cart JS already updates. */
    if ('MutationObserver' in window) {
      document.querySelectorAll('.cart-count').forEach(function (c) {
        var mo = new MutationObserver(function () {
          c.classList.remove('is-pop');
          void c.offsetWidth;
          c.classList.add('is-pop');
        });
        mo.observe(c, { childList: true, characterData: true, subtree: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
